import PropTypes from 'prop-types';
import { login } from '../utils/auth';

/**
 * Login — single button that bounces the user to Cognito Hosted UI.
 *
 * No api_key field, no localStorage. The backend at /auth/login redirects
 * to Cognito; after sign-in, /auth/callback sets an HttpOnly cookie and
 * the SPA reloads with the user authenticated.
 */
function Login({ message }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 border border-gray-700 rounded-2xl p-8 shadow-xl w-full max-w-sm text-center">
        <div className="mb-6">
          <h1 className="text-xl font-semibold text-white">FNI Forms Assistant</h1>
          <p className="text-sm text-gray-400 mt-1">Internal tool — sign in to continue</p>
        </div>

        {message && (
          <p
            role="alert"
            className="mb-4 text-sm text-yellow-300 bg-yellow-900/20 border border-yellow-800 rounded-lg px-3 py-2"
          >
            {message}
          </p>
        )}

        <button
          type="button"
          onClick={login}
          className="w-full px-4 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors"
        >
          Sign in
        </button>

        <p className="mt-4 text-xs text-gray-500">
          You&apos;ll be redirected to the Cognito hosted sign-in page.
          Your credentials never touch this UI; the backend keeps your
          session in an HttpOnly cookie.
        </p>
      </div>
    </div>
  );
}

Login.propTypes = {
  message: PropTypes.string,
};

export default Login;
